import {Spinner} from "react-bootstrap";
import {common} from "../i18n";

export function LoadingSpinner() {
    return (
        <div className="d-flex justify-content-center py-5">
            <Spinner role="status"><span className="visually-hidden">{common.loading}</span></Spinner>
        </div>
    );
}
